import { Dropdown } from 'primereact/dropdown';
import { observer } from 'mobx-react';
import { useSupplierForecast } from './useSupplierForecast';
import SupplierForecastSkeleton from './components/SupplierForecastSkeleton';
import classes from './supplierForecast.module.scss';
import { Button } from 'primereact/button';
import mailIcon from 'assets/icons/mailIcon.svg';
import exportIcon from 'assets/icons/export.svg';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import { supplierForecastAllowedRoles } from 'data/fdp/fdpUserRolesValidations';

const SupplierForecast = () => {
  const {
    userModulesRoles,
    isSupplierForecastDownloading,
    forecastDates,
    isSupplierForecastLoading,
    supplierNames,
    supplierOption,
    fssforecastData,
    nmcforecastData,
    coveredDrugForecastData,
    isAllSupplierForecastDownloading,
    issupplierForecastGenerating,
    supplierForecastData,
    isUnconstrainedForecastProgressLoading,
    percentProgress,
    searchInput,
    getForecastValue,
    handleOptionChange,
    generateSupplierForecast,
    handleExport,
    handleExportAllSuppliers,
  } = useSupplierForecast();

  const checkCurrentMontPlanPeriod = () => {
    const planning_period = new Date(supplierForecastData.PlanningPeriod);
    const currDT = new Date();

    if (
      planning_period.getMonth() === currDT.getMonth() &&
      planning_period.getFullYear() === currDT.getFullYear()
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      {isSupplierForecastLoading ? (
        <SupplierForecastSkeleton />
      ) : (
        <div className={classes.container}>
          {/* dropdown component start */}
          <div className={classes.dropdownContainer}>
            {fssforecastData.length !== 0 || nmcforecastData.length !== 0 || coveredDrugForecastData.length !== 0 ? (
              <Dropdown
                filter
                className={classes.dropdown}
                value={supplierOption}
                options={supplierNames}
                optionLabel="name"
                style={{ width: '40rem' }}
                onChange={e => {
                  handleOptionChange(e.target.value);
                }}
              />
            ) : (
              <div></div>
            )}

            <div>
              {!isSupplierForecastLoading && !checkCurrentMontPlanPeriod() && (
                <Button
                  className={classes.generateBtn}
                  onClick={generateSupplierForecast}
                  loading={issupplierForecastGenerating || isUnconstrainedForecastProgressLoading}
                  disabled={percentProgress.percentage < 100}
                >
                  Generate New Forecast
                </Button>
              )}
            </div>
          </div>
          {percentProgress.percentage < 100 && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                paddingRight: '2rem',
              }}
            >
              <span
                style={{
                  // marginLeft: "-6rem",
                  color: 'red',
                  fontSize: '14px',
                }}
              >
                *Unconstrained Forecast is not 100% yet!!
              </span>
            </div>
          )}
          {/* dropdown component end */}

          {!isSupplierForecastLoading &&
          fssforecastData.length === 0 &&
          nmcforecastData.length === 0 &&
          coveredDrugForecastData.length === 0 ? (
            <div
              style={{
                padding: '1rem',
                fontSize: '2rem',
                textAlign: 'center',
              }}
            >
              No Supplier Forecast data available, Click Generate Forecast to generate
            </div>
          ) : (
            <>
              <div className={classes.disclaimer}>
                Forecast is for planning purposes only and is non-binding.
              </div>
              {/* FSS table container start */}
              <div className={classes.tableContainer}>
                <div className={classes.tableHeading}>MAS</div>
                {!isSupplierForecastLoading && fssforecastData.length === 0 ? (
                  <div
                    style={{
                      padding: '1rem',
                    }}
                  >
                    No Forecast Data for MAS
                  </div>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th className={classes.colNdc10}>NDC10</th>
                        <th className={classes.colDescription}>Description</th>
                        <th className={classes.colLeadTime}>Lead Time</th>
                        <th className={classes.colMoq}>MOQ</th>
                        <th className={classes.colOnHand}>OnHand</th>
                        <th className={classes.colOpenPo}>OpenPo</th>
                        {forecastDates.map((item, idx) => {
                          return (
                            <th key={idx} className={classes.colDate}>
                              {item.label}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {/* {supplierForecastData.filter()} */}
                      {fssforecastData.map((item, idx) => {
                        return (
                          <tr
                            key={idx}
                            style={{
                              backgroundColor:
                                item.NDC10 === searchInput || item.Description === searchInput
                                  ? '#f7eaff'
                                  : '',
                            }}
                          >
                            <td className={classes.colNdc10}>{item.NDC10}</td>
                            <td className={classes.colDescription}>{item.Description}</td>
                            <td className={classes.colLeadTime}>{item.Lead_Time != null ? Math.ceil(item.Lead_Time).toLocaleString('en-US') : '-'}</td>
                            <td className={classes.colMoq}>{item.Pan_Size != null ? Math.ceil(item.Pan_Size).toLocaleString('en-US') : '-'}</td>
                            <td
                              className={classes.colOnHand}
                              style={
                                item.OnHand <= 0
                                  ? { color: 'red', backgroundColor: 'yellow' }
                                  : undefined
                              }
                            >
                              {item.OnHand.toLocaleString('en-US')}
                            </td>
                            <td className={classes.colOpenPo}>{item.OpenPo.toLocaleString('en-US')}</td>
                            {forecastDates.map((_, idx) => {
                              return (
                                <td key={idx} className={classes.colDate}>
                                  {getForecastValue(
                                    'FSS',
                                    item.BulkNDC11,
                                    forecastDates[idx].dateString
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
              {/* FSS table container end */}

              {/* NC table container start */}
              <div className={classes.tableContainer}>
                <div className={classes.tableHeading}>NC</div>
                {!isSupplierForecastLoading && nmcforecastData.length === 0 ? (
                  <div
                    style={{
                      padding: '1rem',
                    }}
                  >
                    No Forecast data for NC
                  </div>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th className={classes.colNdc10}>NDC10</th>
                        <th className={classes.colDescription}>Description</th>
                        <th className={classes.colLeadTime}>Lead Time</th>
                        <th className={classes.colMoq}>MOQ</th>
                        <th className={classes.colOnHand}>OnHand</th>
                        <th className={classes.colOpenPo}>OpenPo</th>
                        {forecastDates.map((item, idx) => {
                          return (
                            <th key={idx} className={classes.colDate}>
                              {item.label}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {/* {supplierForecastData.filter()} */}
                      {nmcforecastData.map((item, idx) => {
                        return (
                          <tr
                            key={idx}
                            style={{
                              backgroundColor:
                                item.NDC10 === searchInput || item.Description === searchInput
                                  ? '#f7eaff'
                                  : '',
                            }}
                          >
                            <td className={classes.colNdc10}>{item.NDC10}</td>
                            <td className={classes.colDescription}>{item.Description}</td>
                            <td className={classes.colLeadTime}>{item.Lead_Time != null ? Math.ceil(item.Lead_Time).toLocaleString('en-US') : '-'}</td>
                            <td className={classes.colMoq}>{item.Pan_Size != null ? Math.ceil(item.Pan_Size).toLocaleString('en-US') : '-'}</td>
                            <td
                              className={classes.colOnHand}
                              style={
                                item.OnHand <= 0
                                  ? { color: 'red', backgroundColor: 'yellow' }
                                  : undefined
                              }
                            >
                              {item.OnHand.toLocaleString('en-US')}
                            </td>
                            <td className={classes.colOpenPo}>{item.OpenPo.toLocaleString('en-US')}</td>
                            {forecastDates.map((_, idx) => {
                              return (
                                <td key={idx} className={classes.colDate}>
                                  {getForecastValue(
                                    'NMC',
                                    item.BulkNDC11,
                                    forecastDates[idx].dateString
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
              {/* NC table container end */}

              {/* Covered Drug table container start */}
              <div className={classes.tableContainer}>
                <div className={classes.tableHeading}>Covered Drug</div>
                {!isSupplierForecastLoading && coveredDrugForecastData.length === 0 ? (
                  <div
                    style={{
                      padding: '1rem',
                    }}
                  >
                    No Forecast data for Covered Drug
                  </div>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th className={classes.colNdc10}>NDC10</th>
                        <th className={classes.colDescription}>Description</th>
                        <th className={classes.colLeadTime}>Lead Time</th>
                        <th className={classes.colMoq}>MOQ</th>
                        <th className={classes.colOnHand}>OnHand</th>
                        <th className={classes.colOpenPo}>OpenPo</th>
                        {forecastDates.map((item, idx) => {
                          return (
                            <th key={idx} className={classes.colDate}>
                              {item.label}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {coveredDrugForecastData.map((item, idx) => {
                        return (
                          <tr
                            key={idx}
                            style={{
                              backgroundColor:
                                item.NDC10 === searchInput || item.Description === searchInput
                                  ? '#f7eaff'
                                  : '',
                            }}
                          >
                            <td className={classes.colNdc10}>{item.NDC10}</td>
                            <td className={classes.colDescription}>{item.Description}</td>
                            <td className={classes.colLeadTime}>{item.Lead_Time != null ? Math.ceil(item.Lead_Time).toLocaleString('en-US') : '-'}</td>
                            <td className={classes.colMoq}>{item.Pan_Size != null ? Math.ceil(item.Pan_Size).toLocaleString('en-US') : '-'}</td>
                            <td
                              className={classes.colOnHand}
                              style={
                                item.OnHand <= 0
                                  ? { color: 'red', backgroundColor: 'yellow' }
                                  : undefined
                              }
                            >
                              {item.OnHand.toLocaleString('en-US')}
                            </td>
                            <td className={classes.colOpenPo}>{item.OpenPo.toLocaleString('en-US')}</td>
                            {forecastDates.map((_, idx) => {
                              return (
                                <td key={idx} className={classes.colDate}>
                                  {getForecastValue(
                                    'COVERED',
                                    item.BulkNDC11,
                                    forecastDates[idx].dateString
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
              {/* Covered Drug table container end */}
            </>
          )}

          {fssforecastData.length !== 0 || nmcforecastData.length !== 0 || coveredDrugForecastData.length !== 0 ? (
            <div className={classes.buttonContainer}>
              <Button className={classes.emailBtn} disabled>
                <img src={mailIcon} alt="mail" />
                Email
              </Button>
              <Button
                className={classes.emailBtn}
                onClick={handleExport}
                loading={isSupplierForecastDownloading}
                disabled={
                  !checkIfFunctionalityEnabled(
                    supplierForecastAllowedRoles.exportSupplierForecastButton,
                    userModulesRoles.fdp,
                    userModulesRoles
                  )
                }
              >
                <img src={exportIcon} alt="export" style={{ transform: 'rotate(180deg)' }} />
                Export
              </Button>
              <Button
                className={classes.emailBtn}
                onClick={handleExportAllSuppliers}
                loading={isAllSupplierForecastDownloading}
                disabled={
                  !checkIfFunctionalityEnabled(
                    supplierForecastAllowedRoles.exportSupplierForecastButton,
                    userModulesRoles.fdp,
                    userModulesRoles
                  )
                }
              >
                <img src={exportIcon} alt="export" style={{ transform: 'rotate(180deg)' }} />
                Export All
              </Button>
              {/* </DownloadTableExcel> */}
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </>
  );
};

export default observer(SupplierForecast);
